import { render, staticRenderFns } from "./select-sprints.vue?vue&type=template&id=2577fd10&"
import script from "./select-sprints.vue?vue&type=script&lang=js&"
export * from "./select-sprints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports